import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import { routes } from './router.js';
import store from './store'; // <-- import your store

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes,
});

new Vue({
    router,
    store, // <-- inject Vuex store here
    render: (h) => h(App),
}).$mount('#app');
